module.exports = (require("./helpers/browser/js-loader")(parcelRequire.resolve("gn3rY"))).then(() => parcelRequire('4bJra'));